import { useState, useEffect } from 'react';

export function useWindowSize() {
  // Initialize state with undefined width/height so server and client renders match
  // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      // Set window width/height to state
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        aspectRatio: window.innerWidth / window.innerHeight,
      });
    }

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty array ensures that effect is only run on mount

  return windowSize;
}

export function useIsSmallScreen(breakpoint = 900) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  const size = useWindowSize();

  useEffect(() => {
    if (size.width < breakpoint) setIsSmallScreen(true);

    if (size.width > breakpoint) setIsSmallScreen(false);
  }, [size, setIsSmallScreen]);

  return isSmallScreen;
}
